import(/* webpackMode: "eager" */ "/vercel/path0/app/list/page.tsx");
